import { Chip } from "@mui/material";
import {
  DeleteWithConfirmButton,
  EditButton,
  DateField,
  FunctionField,
  DatagridConfigurable,
  List,
  TextField,
  TopToolbar,
  SelectColumnsButton,
  CreateButton,
} from "react-admin";

import { ListPaginationByLimit } from "@/components/pagination";
import { useClientApps } from "@/modules/clientApps";
import { hashStringToColor } from "@/utils/colors";

import { PER_PAGE } from "../api";

import { type AppVersionFlagRecord } from "./types";

const ListActions = () => (
  <TopToolbar>
    <SelectColumnsButton />
    <CreateButton />
  </TopToolbar>
);

export const AppVersionFlagsList = () => {
  const { data: { clientAppsObject } = {} } = useClientApps();
  return (
    <List
      title="App Version Flags"
      actions={<ListActions />}
      pagination={<ListPaginationByLimit perPage={PER_PAGE} />}
      storeKey={false}
    >
      <DatagridConfigurable bulkActionButtons={false}>
        <TextField source="id" sortable={false} />
        <DateField source="createdAt" showTime sortable={false} />
        <FunctionField
          label="App name"
          source="clientAppId"
          render={(record: AppVersionFlagRecord) => (
            <Chip
              label={clientAppsObject?.[record.clientAppId].name}
              size="small"
              sx={{
                backgroundColor: hashStringToColor(
                  clientAppsObject?.[record.clientAppId].name,
                ),
                color: "#fff",
              }}
            />
          )}
        />
        <FunctionField
          label="App version"
          source="clientAppId"
          render={(record: AppVersionFlagRecord) =>
            `${record.major}.${record.minor}.${record.patch}`
          }
        />
        <FunctionField
          label="Allow DI"
          source="di"
          sortable={false}
          render={(record: AppVersionFlagRecord) => (
            <Chip
              label={record.di ? "YES" : "NO"}
              color={record.di ? "success" : "error"}
              size="small"
            />
          )}
        />
        <EditButton />
        <DeleteWithConfirmButton />
      </DatagridConfigurable>
    </List>
  );
};
